export default "__VITE_ASSET__CCVPw0fv__"